// extracted by mini-css-extract-plugin
export default {"tag":"JyQyviEusALDxa0MMlrS","graph-wrapper":"_oMvbtT75r54cX9QTgf9","graph-controlls":"fqbgcXFF6Jl6Tziabgnf"};